import { render, staticRenderFns } from "./TiptapCheckbox.vue?vue&type=template&id=156c99b8"
import script from "./TiptapCheckbox.vue?vue&type=script&lang=js"
export * from "./TiptapCheckbox.vue?vue&type=script&lang=js"
import style0 from "./TiptapCheckbox.vue?vue&type=style&index=0&id=156c99b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
